import React from "react";
import { useParams } from "react-router";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { ApplicantListLayout } from "components/Missions/Applicants";
import PageTitle from "components/PageTitle";
import { Grid, PageWrapper } from "components/Containers";
import { APPLICANT_LIST_COLUMNS } from "constants/index";
import { ProfileNav } from "components/Profile";
import { useProfile } from "hooks";

/**
 * MissionApplications
 */
const MissionApplications = () => {
  const intl = useIntl();
  const { id } = useParams();
  const { data, loading } = useProfile({ profileId: id });

  if (loading) return null;

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Applications.Title" })}</title>
      </Helmet>
      <ProfileNav id={id} />
      <PageWrapper>
        <PageTitle subtitle={<FormattedMessage id="Profile.Applications.Title" />} />
        <Grid topMargin>
          <Grid.col start={1} end={13}>
            <ApplicantListLayout
              showAdvancedOptions={false}
              hideOrganizationFilter={true}
              hideMissionFilter={true}
              hideFilters={true}
              hideTabs={true}
              hideProgressMenu={true}
              filtersProp={{ profileId: data?.profile?.id }}
              variablesProp={{ includeScores: false }}
              columns={[
                APPLICANT_LIST_COLUMNS.mission,
                APPLICANT_LIST_COLUMNS.state,
                APPLICANT_LIST_COLUMNS.created,
                APPLICANT_LIST_COLUMNS.applied,
                APPLICANT_LIST_COLUMNS.applicationRate,
                APPLICANT_LIST_COLUMNS.viewButton,
              ]}
            />
          </Grid.col>
        </Grid>
      </PageWrapper>
    </>
  );
};

export default MissionApplications;
